export default __webpack_public_path__ + "7510a3dbf8f1b5b501ac123160d40751.svg";